import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon, notification } from "antd";
import axios from "axios";

import DrawerPlano from "../Drawers/DrawerPlano";
import ModalPlanoAtendimento from "../../components/modals/ModalPlanoAtendimento";
import PlanoRestantes from "../EstabelecimentoPlano/PlanoRestantes";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const PlanosRestantes = () => {
    const [planos, setPlanos] = useState([]);
    const [planoId, setPlanoId] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <>
                    <Link
                        to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                        className="botao-secundario botao-secundario-redondo"
                        onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                        style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                        <Icon type="arrow-left" />
                    </Link>
                </>
            );
        }
    };

    const handleEditarPlano = id => {
        setDrawerVisible(true);
        setPlanoId(id);
    };

    const handleViewPlano = id => {
        setModalVisible(true);
        setPlanoId(id);
    };

    const handleCloseDrawer = () => {
        setDrawerVisible(false);
        setPlanoId(null);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setPlanoId(null);
    };

    const carregarPlanos = () => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/atendimento/carregar-planos-atendimento",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                tipo: "plano_atendimento_especializado"
            }
        })
            .then(response => {
                setPlanos(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("Ocorreu um erro ao carregar os planos de atendimento.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const atualizarListagem = () => {
        setDrawerVisible(false);
        setPlanoId(null);
        carregarPlanos();
    };

    const handleDelete = () => {
        setModalVisible(false);
        setPlanoId(null);
        carregarPlanos();
    };

    useEffect(() => {
        carregarPlanos();
    }, []);

    return (
        <>
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="controlos controlos-fundo ">
                        <div className="bloco-esquerda">
                            <span className="titulo-pagina">Planos de Atendimento</span>
                        </div>
                        <div className="bloco-direita">
                            <Link
                                to="#"
                                className="botao-principal botao-principal-redondo"
                                title="Novo atendimento"
                                onClick={() => setDrawerVisible(true)}
                            >
                                +
                            </Link>
                            {montarBotaoVoltar()}
                        </div>
                    </div>
                    <div className="bloco">
                        <div className="bloco-atendimentos">
                            <div className="titulo-bloco-atendimentos">Planejamentos Criados</div>
                            <div className="lista-planos-atendimentos">
                                {planos.length === 0 && 'Nenhum plano criado ainda. Clique no botão " + " para criar seu primeiro plano.'}
                                {planos.map(plano => (
                                    <React.Fragment key={plano.id}>
                                        <PlanoRestantes onEdit={handleEditarPlano} onView={handleViewPlano} plano={plano} />
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DrawerPlano id={planoId} visible={drawerVisible} onClose={handleCloseDrawer} atualizarListagem={atualizarListagem} />
            <ModalPlanoAtendimento id={planoId} visible={modalVisible} onCancel={handleCloseModal} onDelete={handleDelete} />
        </>
    );
};

export default PlanosRestantes;
